import React, {useCallback, useContext} from 'react';

import {RemoveButton} from 'src/components/remove-button';

import {Integer} from '@pb/kit-component-formatters';
import {Group} from '@pb/kit-component-group';
import {LocaleContext} from '@pb/kit-context-locale';

import {mcpAlertsTableCell, mcpAlertsTableRow} from './alerts-view.module.styl';

type Props = {
    contractNumber: string,
    contractId: number,
    creditValue?: number,
    overageValue?: number,
    onRemove: (contractId: number, value: number, type: 'credits' | 'overages') => void,
    showCaption: boolean,
    disabled?: boolean,
};

export const AlertItem = (props: Props) => {
    const {locale} = useContext(LocaleContext);
    const {
        onRemove, contractNumber, contractId,
        creditValue, overageValue, showCaption, disabled,
    } = props;

    const onRemoveCredit = useCallback(() => {
        onRemove(contractId, creditValue!, 'credits');
    }, [contractId, creditValue, onRemove]);

    const onRemoveOverage = useCallback(() => {
        onRemove(contractId, overageValue!, 'overages');
    }, [contractId, overageValue, onRemove]);

    return (
        <div className={mcpAlertsTableRow}>
            <div className={mcpAlertsTableCell}>
                {showCaption ? contractNumber : ''}
            </div>
            <div className={mcpAlertsTableCell}>
                {creditValue !== undefined ? (
                    <Group justify="space-between" alignItems="center">
                        <span>{Integer.format(creditValue, locale)}</span>
                        <RemoveButton disabled={disabled} onRemove={onRemoveCredit}/>
                    </Group>
                ) : null}
            </div>
            <div className={mcpAlertsTableCell}>
                {overageValue !== undefined ? (
                    <Group justify="space-between" alignItems="center">
                        <span>{Integer.format(overageValue, locale)}</span>
                        <RemoveButton disabled={disabled} onRemove={onRemoveOverage}/>
                    </Group>
                ) : null}
            </div>
        </div>
    );
};
